import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { User, LogOut, Palette } from 'lucide-react';
import Logo from './Logo';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const ForumTopBar: React.FC = () => {
  const navigate = useNavigate();
  const { user, isLoggedIn, openAuthModal, logout } = useAuth();
  const { setShowThemeSelector } = useTheme();

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '14px 20px',
        background: 'rgba(6, 9, 24, 0.92)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(51, 65, 85, 0.25)',
      }}
    >
      <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
        <Logo />
      </Link>

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <motion.button
          type="button"
          whileTap={{ scale: 0.95 }}
          onClick={() => setShowThemeSelector(true)}
          aria-label="Tema seç"
          style={{
            padding: '8px 12px',
            borderRadius: '10px',
            border: '1px solid rgba(51, 65, 85, 0.35)',
            background: 'rgba(30, 41, 59, 0.4)',
            color: '#94a3b8',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Palette size={16} />
        </motion.button>
        {isLoggedIn && user ? (
          <>
            <span style={{ color: '#94a3b8', fontSize: '13px', fontWeight: 500 }}>{user.name}</span>
            <motion.button
              type="button"
              whileTap={{ scale: 0.95 }}
              onClick={logout}
              style={{
                background: 'rgba(239, 68, 68, 0.1)',
                border: '1px solid rgba(239, 68, 68, 0.2)',
                color: '#ef4444',
                padding: '8px 14px',
                borderRadius: '10px',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              }}
            >
              <LogOut size={14} />
              Çıkış
            </motion.button>
          </>
        ) : (
          <motion.button
            type="button"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => openAuthModal('login')}
            className="btn-shimmer"
            style={{
              background: 'var(--gradient-primary)',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '12px',
              border: 'none',
              fontWeight: 600,
              fontSize: '14px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <User size={15} />
            Giriş Yap
          </motion.button>
        )}
        <motion.button
          type="button"
          whileTap={{ scale: 0.97 }}
          onClick={() => navigate('/')}
          style={{
            padding: '10px 16px',
            borderRadius: '10px',
            border: '1px solid rgba(51, 65, 85, 0.35)',
            background: 'rgba(30, 41, 59, 0.4)',
            color: '#94a3b8',
            fontSize: '13px',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Ana sayfa
        </motion.button>
      </div>
    </header>
  );
};

export default ForumTopBar;
